var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 55C12.3118 55 0 42.6882 0 27.5C0 12.3118 12.3118 0 27.5 0C42.6882 0 55 12.3118 55 27.5C55 42.6882 42.6882 55 27.5 55ZM24.75 35.75V41.25H30.25V35.75H24.75ZM30.25 31.2262C32.4601 30.5601 34.3574 29.1224 35.5964 27.1748C36.8354 25.2272 37.3337 22.8994 37.0005 20.6153C36.6673 18.3312 35.5248 16.2427 33.781 14.7303C32.0373 13.2178 29.8083 12.382 27.5 12.375C25.2747 12.3743 23.1179 13.1447 21.3967 14.5551C19.6754 15.9655 18.496 17.9287 18.0593 20.1107L23.4548 21.1915C23.6079 20.4254 23.9754 19.7186 24.5145 19.1532C25.0536 18.5879 25.7422 18.1872 26.5002 17.9979C27.2581 17.8086 28.0542 17.8385 28.7959 18.0839C29.5375 18.3294 30.1942 18.7804 30.6895 19.3845C31.1849 19.9886 31.4985 20.7209 31.5939 21.4963C31.6893 22.2717 31.5625 23.0582 31.2284 23.7644C30.8942 24.4705 30.3664 25.0672 29.7064 25.4852C29.0464 25.9031 28.2812 26.125 27.5 26.125C26.7707 26.125 26.0712 26.4147 25.5555 26.9305C25.0397 27.4462 24.75 28.1457 24.75 28.875V33H30.25V31.2262Z",
    fill: "#1F21E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestStructure);
export default __webpack_public_path__ + "static/media/test_structure.2b1c9a7daa9456e0734e243bfcc53ffb.svg";
export { ForwardRef as ReactComponent };